import { SecondaryButton } from '../../Button'
import { SubText } from '../../Text'
import { PresetsContainerStyled } from '../styles/PresetsContainerStyled'

interface DatePickerPresetsProps {
  title?: string
  presets: { label: string }[]
  onClick: (preset: { label: string }) => void
}

export const DatePickerPresets = ({
  title,
  presets,
  onClick,
}: DatePickerPresetsProps) => (
  <PresetsContainerStyled>
    {title && <SubText bold>{title}</SubText>}

    {presets.map((preset) => (
      <SecondaryButton key={preset.label} onClick={() => onClick(preset)}>
        {preset.label}
      </SecondaryButton>
    ))}
  </PresetsContainerStyled>
)
